import { EventEmitter } from 'expo-modules-core';

export default {
  getItem(keyName: string) {
    return localStorage.getItem(keyName);
  },
  setItem(keyName:string, value: string) {
    localStorage.setItem(keyName, value);
  }
};
